<h1 mat-dialog-title>Posizione su Mappa</h1>

<div mat-dialog-content>
  <div fxLayout="row" id="search-bar">
    <mat-form-field appearance="outline" fxFlex>
      <mat-label>Cerca</mat-label>
      <mat-icon matPrefix>search</mat-icon>
      <input #searchbox matInput [ngModel]="data.searchText" />
    </mat-form-field>
  </div>
  <agm-map
    [latitude]="center?.latitude"
    [longitude]="center?.longitude"
    (mapClick)="createMarker($event)"
    [zoom]="center ? 10 : 6"
    (mapReady)="onMapReady($event)"
  >
    <agm-marker
      *ngIf="data.place"
      [markerDraggable]="true"
      (dragEnd)="markerDragEnd($event)"
      [latitude]="data.place.position.latitude"
      [longitude]="data.place.position.longitude"
    ></agm-marker>
  </agm-map>
</div>
<div mat-dialog-actions>
  <button mat-button color="warn" [mat-dialog-close]="null">
    Elimina
  </button>
  <span fxFlex></span>
  <button mat-button (click)="close()">Annulla</button>
  <button
    mat-raised-button
    color="primary"
    [mat-dialog-close]="data.place"
    cdkFocusInitial
  >
    Ok
  </button>
</div>
